import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import { ITareaTomarLiberarPost } from "../../../interfaces/backendApi/tareaTomarLiberar";
import {
  BackendTareaTomarLiberarOperador,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_json from "../../../dataJson/tomarLiberar.json";
import { formatearMensajeBackend } from "../../../apis/helper/helperApi";
import { TypeStatus } from "../../helpers/constantes";
interface State {
  tareaTomarLiberarOperador: any[];
  status: TypeStatus;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
  assigned_id: string;
}

const initialState: State = {
  tareaTomarLiberarOperador: [],
  status: "idle",
  isLoading: false,
  Success: false,
  Mensaje: "",
  error: null,
  assigned_id: "",
};

export interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}

const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};

export const defaultResps: defaultResponse = {
  data: [],
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};

const tareaTomarLiberarOperadorSlice = createSlice({
  name: "tareaTomarLiberarOperador",
  initialState,
  reducers: {
    setTareaTomarLiberarOperador: (state, action: PayloadAction<any[]>) => {
      state.tareaTomarLiberarOperador = action.payload;
    },
    getTareaTomarLiberarOperador: (state, action: PayloadAction<any[]>) => {
      state.tareaTomarLiberarOperador = action.payload;
    },
    setClearTareaTomarLiberarOperador: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
    setAssigned_id: (state, action: PayloadAction<string>) => {
      state.assigned_id = action.payload;
    },
  },
});

export const setBackendTareaTomarLiberarOperador =
  (iTareaTomarLiberarPost: ITareaTomarLiberarPost): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));

    try {
      let response: AxiosResponse = await BackendTareaTomarLiberarOperador(
        iTareaTomarLiberarPost,
      );

      const isError =
        response.data?.Success === false ||
        (response.data?.ResultadoSolicitud !== undefined &&
          response.data?.ResultadoSolicitud !== 200);

      if (isError) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        dispatch(setSuccess(false));
        response.status = 0;
      } else {
        dispatch(setTareaTomarLiberarOperador(response.data.Data));
        dispatch(setIsLoading(false));
        dispatch(setStatus("succeeded"));
        dispatch(setSuccess(true));
        response.status = 1;
      }
      dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
      dispatch(setAssigned_id(iTareaTomarLiberarPost.assigned_id));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setSuccess(false));
      dispatch(setStatus("failed"));

      if (error.response?.status === 401) {
        dispatch(setStatus("noAutorice"));
        dispatch(
          setMensaje(
            formatearMensajeBackend(
              "Tu sesión ha expirado. Vuelve a iniciar sesión",
            ),
          ),
        );
      } else if (error.response) {
        // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
        console.error(
          "Error de servidor:",
          error.response.status,
          error.response.data,
        );

        const errorData = error.response.data;
        const mensajeBackend = errorData?.Mensaje;
        const resultadoSolicitud = errorData?.ResultadoSolicitud;

        if (
          mensajeBackend &&
          (resultadoSolicitud !== 200 || errorData?.Success === false)
        ) {
          dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
        } else {
          dispatch(
            setMensaje(
              `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
            ),
          );
        }
      } else if (error.request) {
        console.error("Error de conexión:", error.message);
        dispatch(
          setMensaje(
            "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
          ),
        );
      } else {
        console.error("Error de red o solicitud:", error.message);
        dispatch(
          setMensaje(
            "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
          ),
        );
      }
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
      if (getCurrentDomain() === "localhost") {
        dispatch(setIsLoading(true));
        let response = defaultResp;
        response.data = mock_json;

        const mockData: any = mock_json;
        const isErrorMock =
          mockData?.Success === false ||
          (mockData?.ResultadoSolicitud !== undefined &&
            mockData?.ResultadoSolicitud !== 200);

        if (isErrorMock) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
          response.status = 0;
        } else {
          dispatch(setTareaTomarLiberarOperador(response.data.Data));
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
          response.status = 1;
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
        dispatch(setAssigned_id(iTareaTomarLiberarPost.assigned_id));
        const mock401 = await import("../../../dataJson/401.json");
        if (mock401.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        }
      }
    }
  };

export const setBackendClearTareaTomarLiberarOperador =
  (): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      let response = defaultResp;
      dispatch(setTareaTomarLiberarOperador([]));
      dispatch(setIsLoading(false));
      dispatch(setStatus("idle"));
      dispatch(setSuccess(false));
      dispatch(setAssigned_id(""));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
      dispatch(setSuccess(false));
      dispatch(setAssigned_id(""));
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const {
  setTareaTomarLiberarOperador,
  getTareaTomarLiberarOperador,
  setClearTareaTomarLiberarOperador,
  setIsLoading,
  setStatus,
  setResult,
  setSuccess,
  setMensaje,
  setAssigned_id,
} = tareaTomarLiberarOperadorSlice.actions;

export default tareaTomarLiberarOperadorSlice.reducer;
